import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Engineering module landing page.
 *
 * Owner (2026-10-05): "in engineering module put DMS, task management etc." The page lists
 * the modules the team uses and the KPI reports that matter to it (DeptLandingSections);
 * each card shows only when the person may open it, with the same gates as the sidebar
 * and the Workflows hub. The route is gated by dept.engineering in allRoutes.js.
 */
const TOOLS = [
    "dmsAll", "dmsCreateEcn", "dmsMyDrafts", "dmsMyApprovals", "dmsRelease",
    "tasks", "tasksCreate", "tasksAssigned",
    "mafia", "di", "perflexion", "cr", "projectsAwaiting", "epoCreate", "toolTracker",
];
const REPORTS = ["dmr-performance-quality", "summary-otd"];

const Engineering = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-pencil-ruler-2-line"
                        eyebrow="Design"
                        title="Engineering"
                        subtitle="Drawings, BOMs, and design workflow"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Engineering" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Engineering tools"
                        description="Documents, change notices, tasks and inspection"
                        icon="ri-pencil-ruler-2-line"
                    />
                    <DeptReportsGrid ids={REPORTS} />

                    <ComingSoonCard
                        compact
                        icon="ri-pencil-ruler-2-line"
                        title="More for Engineering later"
                        message="Ideas for later: a drawing browser by part number, BOM lookup and a drawing approval workflow. The cards above are live today."
                        tone="success"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Engineering;
